import { AfterViewInit, DestroyRef, Directive, inject, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroupDirective } from '@angular/forms';
import { debounceTime } from 'rxjs';
import { Step } from '../types';
import { GoogleAnalyticsErrorService } from '../google-analytics';

@Directive({
  selector: '[lxFormErrorTracker]',
  standalone: true,
})
export class FormErrorTrackerDirective implements AfterViewInit {
  @Input() currentStep: Step | undefined;

  private readonly formGroupDirective = inject(FormGroupDirective);
  private readonly googleAnalyticsErrorService = inject(GoogleAnalyticsErrorService);
  private readonly destroyRef = inject(DestroyRef);

  ngAfterViewInit(): void {
    this.formGroupDirective.form.statusChanges.pipe(debounceTime(1000), takeUntilDestroyed(this.destroyRef)).subscribe(() => this.checkErrors());
  }

  private checkErrors(): void {
    const form = this.formGroupDirective.form;
    const fields: string[] = [];
    const messages: string[] = [];

    Object.keys(form.controls).forEach((controlName) => {
      const control = form.get(controlName);

      if (control && control.invalid && control.touched) {
        const errors = control.errors;

        if (errors) {
          fields.push(controlName);
          messages.push(JSON.stringify(errors));
        }
      }
    });

    if (form.invalid && form.touched && fields.length && messages.length) {
      this.googleAnalyticsErrorService.trackFormValidationError(this.currentStep.googleAnalyticsEvent, fields.join(', '), messages.join(', '));
    }
  }
}
